export default "__VITE_ASSET__C6B7WoIU__"